<script setup lang="ts">
import { SkylabPorthole } from '@/layouts'
import SignInPage from './SignInPage.vue'
</script>

<template>
  <SkylabPorthole>
    <div class="w-full max-w-sm bg-card text-foreground rounded-2xl border border-border shadow-[0_40px_100px_-15px_rgba(0,0,0,0.9),0_0_120px_-20px_rgba(255,255,255,0.15)] px-6 py-6 overflow-hidden">
      <SignInPage />
    </div>
  </SkylabPorthole>
</template>
